import { z } from 'zod';
import { paginationQuerySchema } from '../common/envelope.js';
export const taskStatusSchema = z.enum(['open', 'in_progress', 'completed', 'cancelled']);
export const taskPrioritySchema = z.enum(['low', 'normal', 'high']);
export const taskKindSchema = z.enum(['todo', 'call', 'email', 'meeting']);
export const taskRelatedToTypeSchema = z.enum(['lead', 'contact', 'company', 'opportunity']);
const relatedRecordRefinement = (shape) => z.object(shape).refine((v) => [v.leadId, v.contactId, v.companyId, v.opportunityId].filter(Boolean).length <= 1, {
    message: 'A task can relate to at most one record',
});
export const createTaskSchema = relatedRecordRefinement({
    title: z.string().trim().min(1).max(200),
    description: z.string().trim().max(4000).optional(),
    kind: taskKindSchema.default('todo'),
    priority: taskPrioritySchema.default('normal'),
    dueAt: z.string().datetime().optional(),
    remindAt: z.string().datetime().optional(),
    ownerId: z.string().uuid().optional(),
    leadId: z.string().uuid().optional(),
    contactId: z.string().uuid().optional(),
    companyId: z.string().uuid().optional(),
    opportunityId: z.string().uuid().optional(),
});
export const updateTaskSchema = z
    .object({
    title: z.string().trim().min(1).max(200).optional(),
    description: z.string().trim().max(4000).optional(),
    kind: taskKindSchema.optional(),
    status: taskStatusSchema.optional(),
    priority: taskPrioritySchema.optional(),
    dueAt: z.string().datetime().optional(),
    remindAt: z.string().datetime().optional(),
    ownerId: z.string().uuid().optional(),
    version: z.number().int().nonnegative(),
})
    .strict();
export const listTasksQuerySchema = paginationQuerySchema.extend({
    status: taskStatusSchema.optional(),
    ownerId: z.string().uuid().optional(),
    /** docs/architecture screen "Tasks": My / Team / Overdue / Upcoming.
     * Ignored when any of the record filters below are set — a record's
     * "Open tasks" widget (Lead/Contact/Company/Deal detail) wants every
     * open task on that record regardless of who owns it, not "my" tasks. */
    view: z.enum(['mine', 'team', 'overdue', 'upcoming', 'completed']).default('mine'),
    leadId: z.string().uuid().optional(),
    contactId: z.string().uuid().optional(),
    companyId: z.string().uuid().optional(),
    opportunityId: z.string().uuid().optional(),
});
export const taskResponseSchema = z.object({
    id: z.string().uuid(),
    title: z.string(),
    description: z.string().nullable(),
    kind: taskKindSchema,
    status: taskStatusSchema,
    priority: taskPrioritySchema,
    dueAt: z.string().datetime().nullable(),
    remindAt: z.string().datetime().nullable(),
    owner: z.object({ id: z.string().uuid(), displayName: z.string() }).nullable(),
    /** Task.leadId/contactId/companyId/opportunityId are informal references
     * (no Prisma relation) — resolved server-side to whichever one is set,
     * or null for a task with no related record. */
    relatedTo: z.object({ type: taskRelatedToTypeSchema, id: z.string().uuid(), label: z.string() }).nullable(),
    completedAt: z.string().datetime().nullable(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
    version: z.number().int(),
});
export const taskCountsResponseSchema = z.object({
    mine: z.number().int(),
    team: z.number().int(),
    overdue: z.number().int(),
    upcoming: z.number().int(),
    completed: z.number().int(),
    dueToday: z.number().int(),
});
//# sourceMappingURL=schemas.js.map